import { useLocale } from './use-locale';

/**
 * An ISO 3166 code as a country name in the admin's language, from the platform itself
 * (`Intl.DisplayNames`) rather than a catalogue of two hundred names to keep in step. A
 * code the platform does not know is shown as sent.
 */
export function useNationalityLabel(code: string | undefined): string | undefined {
  const { locale } = useLocale();
  if (!code) return undefined;
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(code) ?? code;
  } catch {
    return code;
  }
}
